import React, {useEffect, useState} from "react";
import styled from "styled-components";

const HowWeWork = ({howWeWorkData = {}}) => {
  const {title = "", subtitle = "", subtitleMobile = "", infoBlocks = [], mapImage = "", mobImage = ""} = howWeWorkData;
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 700);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  if (isMobile === null) return null;
  return (
    <Section>
      <Title>{title}</Title>
      <Subtitle>
        {isMobile ? subtitleMobile : subtitle}
      </Subtitle>
      <MapCard>
        <InfoBlock>
          <Divider />
          {infoBlocks.map((block, index) => (
            <InfoPair key={index}>
              <InfoTitle>{block.title}</InfoTitle>
              <InfoSub>{block.subtitle}</InfoSub>
            </InfoPair>
          ))}
        </InfoBlock>
        <MapWrapper>
          {isMobile ? (
            <MapImg
              alt="india map"
              loading="lazy"
              src={mobImage}
              width={800}
              height={600}
              sizes="100vw"
              decoding="async"
            />
          ) : (
            <>
              <ImageWrapper>
                <MapImg
                  alt="india map"
                  loading="lazy"
                  src={mapImage}
                  width={1200}
                  height={700}
                  sizes="60vw"
                  decoding="async"
                />
              </ImageWrapper>
            </>
          )}
        </MapWrapper>
      </MapCard>
    </Section>
  );
};

const Section = styled.section`
  width: 100%;
  margin: 10rem 0;

  @media (max-width: 768px) {
    margin: 5rem 0;
  }
`;

const Title = styled.h2`
  font-family: 'DM Serif Display';
  color: #000000;
  font-size: 5rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 2.7rem;
  }
`;

const Subtitle = styled.p`
  font-size: 2rem;
  font-family: 'Lato';
  font-weight: 400;
  color: #7E7E7E;
  text-align: center;
  max-width: 900px;
  margin: 0 auto 36px auto;
  line-height: 32px;

  @media (max-width: 768px) {
    font-size: 1.33rem;
    max-width: 95vw;
    line-height: 1.5;
    margin-bottom: 2rem;
  }
`;

const MapCard = styled.div`
  background: #1c1c1c;
  border-radius: 36px;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto;
  min-height: 350px;
  display: flex;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    border-radius: 24px;
    width: 85%;
    min-height: unset;
    padding-bottom: 24px;
  }
`;
const InfoBlock = styled.div`
  flex: 1.2;
  padding: 48px 32px 10px 80px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;

  @media (max-width: 768px) {
    order: 2;
    padding: 24px 12px 0 12px;
    margin-top: 0;
    align-items: center;
    text-align: center;
  }
`;

const InfoTitle = styled.div`
  font-size: 3rem;
  font-family: 'Lato';
  font-weight: 400;
  margin-bottom: 4px;
  color: #FFFFFF;
  @media (max-width: 768px) {
    font-size: 1.77rem;
    font-weight: 600;
  }
`;

const InfoSub = styled.div`
  font-size: 2rem;
  color: #6F6F6F;
  margin-bottom: 57px;
  font-weight:400;
  font-family: 'Lato';
  @media (max-width: 768px) {
    font-size: 1.55rem;
    margin-bottom: 10px;
  }
`;

const MapWrapper = styled.div`
  flex: 2;
  position: relative;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    order:1;
    min-height: 220px;
    width: 100%;
    height: 220px;
    margin-bottom: 16px;
  }
`;

const ImageWrapper = styled.div`
  display: inline-block;
  margin-right: 40px;

  &:last-child {
    margin-right: 0;
  }
`;

const MapImg = styled.img`
  width: 100%;
  height: 95%;
  display: block;
  border-radius: 0 36px 36px 0;
  position: absolute;
  object-fit: contain;
  right: 2px;
  position: absolute;
  top: 10px;

  @media (max-width: 768px) {
    position: static !important;
    width: 100% !important;
    height: auto !important;
    border-radius: 0;
    max-width: 100%;
  }
`;

const Divider = styled.div`
  width: 90%;
  height: 1px;
  background: white;
  opacity: 0.2 ;
  margin: 0 auto 35px auto;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const InfoPair = styled.div`
  display: inline-block;

  @media (max-width: 768px) {
    margin-bottom: 18px;
  }
`;
export default HowWeWork;